import { normalize, schema } from "normalizr";
import { change } from "redux-form";
import { fetchCities } from "./configProcesses";
import { apiGet } from "./helpers/api";

const FORM_NAME = "payment";

const postalCodeAddress = new schema.Entity("postalCodeAddresses", {
  meta: { city: new schema.Entity("cities") },
});

export const searchAddressForPayment = (dispatch, postalCode) => {
  const postalCodeLength = postalCode?.replace(/[^0-9]+/g, "")?.length == 8;

  if (!postalCode || !postalCodeLength) return;

  dispatch({ type: "CHECKOUT_START_ADDRESS_LOADING" });

  return apiGet(`/api/v1/public/postal_codes/${postalCode}`)
    .then((response) => {
      const data = response.body.data;
      const { neighborhood, stateId, street, cityId } = data;

      dispatch({
        type: "CHECKOUT_ADDRESS_FETCHED",
        zipCode: postalCode,
        street,
        neighborhood,
        cityId,
        stateId,
      });
      dispatch({
        type: "CITIES_FETCHED",
        ...normalize(data, postalCodeAddress),
      });
      dispatch(change(FORM_NAME, "customerData[street]", street));
      dispatch(change(FORM_NAME, "customerData[neighborhood]", neighborhood));
      dispatch(change(FORM_NAME, "customerData[stateId]", stateId));
      dispatch(change(FORM_NAME, "customerData[cityId]", cityId));
      dispatch({ type: "CHECKOUT_END_ADDRESS_LOADING" });
    })
    .catch(() => {
      dispatch({ type: "CHECKOUT_ADDRESS_FETCHED", zipCode: postalCode });
      dispatch({ type: "CHECKOUT_END_ADDRESS_LOADING" });
    });
};

export const searchAddressForProfileEdit = (
  dispatch,
  { postalCode, formName }
) => {
  if (!postalCode || postalCode?.replace(/[^0-9]+/g, "")?.length !== 8) return;
  dispatch(change(formName, "searchingAddress", true));

  return apiGet(`/api/v1/public/postal_codes/${postalCode}`)
    .then(async (response) => {
      const { neighborhood, stateId, street, cityId, meta } = response.body.data;
      let resolvedCityId = cityId;

      dispatch({
        type: "CITIES_FETCHED",
        ...normalize(response.body.data, postalCodeAddress),
      });
      dispatch(change(formName, "searchingAddress", false));
      dispatch(change(formName, "searchedAddressZip", postalCode));
      if (street) {
        dispatch(change(formName, "address", street));
      }
      if (neighborhood) {
        dispatch(change(formName, "addressNeighborhood", neighborhood));
      }
      if (stateId) {
        dispatch(change(formName, "stateId", stateId));
        dispatch(change(formName, "cityId", ""));
        const cities = await fetchCities(dispatch, stateId);
        const resolvedCityName = meta?.city?.name || meta?.cityName;
        if (!resolvedCityId && resolvedCityName) {
          resolvedCityId = cities?.find((city) => (
            normalizeAddressName(city.name) === normalizeAddressName(resolvedCityName)
          ))?.id;
        }
      } else {
        dispatch(change(formName, "stateId", ""));
        dispatch(change(formName, "cityId", ""));
      }
      if (resolvedCityId) {
        dispatch(change(formName, "cityId", resolvedCityId));
      }
      dispatch(change(formName, "resolvedCityName", meta?.city?.name || meta?.cityName || ""));
      dispatch(change(formName, "resolvedStateName", meta?.stateName || meta?.stateUf || ""));
      dispatch(change(formName, "searchedAddress", street));
      dispatch(change(formName, "searchedAddressNeighborhood", neighborhood));
      dispatch(change(formName, "searchedStateId", stateId));
      dispatch(change(formName, "searchedCityId", resolvedCityId));
    })
    .catch(() => {
      dispatch(change(formName, "searchingAddress", false));
    });
};

function normalizeAddressName(value) {
  return value
    ?.normalize("NFD")
    ?.replace(/[\u0300-\u036f]/g, "")
    ?.toLowerCase()
    ?.replace(/[^a-z0-9]+/g, " ")
    ?.trim();
}
